import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-wizard-infos-produit',
  templateUrl: './wizard-infos-produit.component.html',
  styleUrls: ['../../base/wizard/wizard-hp-base-component.scss', './wizard-infos-produit.component.scss'],
  //host: {'class': 'app-wizard-answers-menu'},
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideInOut', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(-220%,0,0)'

      })),
      state('out', style({
        transform: 'translate3d(135px, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),

    trigger('slideInOutMobile', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(0,500%,0)'

      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),
    trigger('reglageSlideOut', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(0,500%,0)'

      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),
    trigger('slideInOutRigth', [
      state('in', style({
        transform: 'translate3d(200%,0,0)'
      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('slideInOutForme', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(-240%,0,0)'

      })),
      state('out', style({
        transform: 'translate3d(135px, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ])
  ]

})             
export class WizardInfosProduitComponent extends WizardHpBaseComponent implements OnInit {
  @Input() stateDetail = "in";
  public product :any;
  constructor(chgDetectorRef: ChangeDetectorRef, mainSimulateur: SimulateurComponent, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);

    this.product = this.getHpService().getGlobaldata();

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getHpService().emitDataChange();
  }
  
  ngOnChanges(changes: SimulateurComponent) {
    if (changes.stateDetail) { // also add this check 
      console.log('Input data changed:', this.stateDetail);
    }
  }
  showDetail()
  {
   this.getSimulateur().showDetail();
   this.getChangeDetectorRef().detectChanges();
  }
  public getglobalData():any
  {
  return this.getHpService().getGlobaldata();
  }
}
